import React from 'react';
import {Button, Feed, Icon, Tab} from 'semantic-ui-react';

export const ErrorSelfAssignTask = () => {
  return (
    <Tab.Pane attached={false}>
      <Feed>
        <Feed.Event>
          <Feed.Label className="callIconBox">
            <Icon name="call" className="call-icon" />
          </Feed.Label>
          <Feed.Content>
            <Feed.Summary>Self Assign Task Error</Feed.Summary>
            <Feed.Meta>
              <Feed.Like>Error constructing Self Assign Task Component</Feed.Like>
            </Feed.Meta>
          </Feed.Content>
          <Feed.Label>
            <Button circular style={{width: '30px', paddingLeft: '5px', paddingRight: '5px'}} className="ean">
              T
            </Button>
          </Feed.Label>
        </Feed.Event>
      </Feed>
    </Tab.Pane>
  );
};
